import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaExclamationTriangle } from "react-icons/fa";
import "../../styles/rh-modern-ui.css";

const MySwal = withReactContent(Swal);

const ConfirmDeleteModal = ({ show, handleClose, employe, token, refreshData }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    if (!employe || !employe.id_contrat) {
      MySwal.fire("Erreur", "Aucun contrat sélectionné", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.patch(
        `contrats/${employe.id_contrat}/disable`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      MySwal.fire("Contrat supprimé 🗑", res.data?.message || "", "success");
      refreshData();
      handleClose();
    } catch (err) {
      const msg = err.response?.data?.detail?.message || err.response?.data?.detail || "Échec de la suppression";
      MySwal.fire("Erreur ❌", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" className="rh-modern-modal">
      <Modal.Header closeButton className="rh-modal-header rh-modal-header-danger">
        <div>
          <Modal.Title><FaExclamationTriangle className="me-2" />Confirmer la suppression</Modal.Title>
          <div className="rh-modal-subtitle">Le contrat sera désactivé du registre actif.</div>
        </div>
      </Modal.Header>
      <Modal.Body className="rh-modal-body">
        <div className="rh-delete-warning">
          Êtes-vous sûr de vouloir supprimer ce contrat
          {employe?.type_contrat && (
            <> (<strong>{employe.type_contrat}</strong> — {employe.nom_employe} {employe.prenom_employe})</>
          )}
          ?
        </div>
      </Modal.Body>
      <Modal.Footer className="rh-modal-footer">
        <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleConfirmDelete} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Supprimer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
